import React from 'react';
import Lottie from 'lottie-react';
import map from '../../static/lotties/map.json';

const WhereWeAreSection = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  return (
    <section id='where-we-are' className='bg-white '>
      <div className='max-w-[1050px] mx-auto'>
        <div className='grid grid-cols-1 gap-1 lg:grid-cols-2 gap-y-10'>
          <div className='flex items-center justify-center pt-12 pb-6 lg:justify-start lg:py-0'>
            <div className='space-y-8'>
              <h6
                className='text-JeetarBlack text-center text-2xl leading-[28px] lg:text-[52px] lg:leading-[60px] font-bold lg:text-left'
                data-aos='fade-up'
                data-aos-duration='1500'>
                Where
                <br />
                we are today ?
              </h6>
              <p
                className='px-10 lg:px-0 text-sm lg:text-[1.2em] text-center mx-auto lg:ml-0 lg:text-left text-k2Black lg:max-w-[350px]'
                data-aos='fade-up'
                data-aos-duration='1000'>
                Let us know which city/cities you would like us to extend our
                services.
              </p>
              <div className='flex items-center justify-center lg:block'>
                <button
                  className='transition duration-300 ease-in-out transform btn text-kBlue hover:-translate-y-1 hover:scale-120'
                  data-aos='fade-up'
                  data-aos-duration='1000'>
                  Send Request&nbsp;&nbsp;&#8594;
                </button>
              </div>
            </div>
          </div>
          <div className='flex items-center justify-center -ml-5 lg:-ml-12 lg:block'>
            {/* <img
              src='/images/map.svg'
              className='w-full h-full mx-auto -ml-5 sm:ml-0'
              data-aos='fade-up'
              data-aos-duration='800'
            /> */}
            <Lottie
              animationData={map}
              options={defaultOptions}
              className='w-full  xl:w-[865px]'
            />
          </div>
        </div>
      </div>

      {/* <div className='text-center'>
        <h6>Currently in Lagos and Ibadan</h6>
        <p>
          Is your city missing? Don't worry, we’re coming soon. Check out our
          <Link to='/' className='underline'>
            {' '}
            delivery areas.
          </Link>
        </p>
      </div> */}
    </section>
  );
};

export default WhereWeAreSection;
